import request from '@/utils/request'

export const uploadApi = {
  // 上传图片
  uploadImage(file) {
    const formData = new FormData()
    formData.append('file', file)
    
    const sessionId = localStorage.getItem('sessionId')
    if (sessionId) {
      formData.append('sessionId', sessionId)
    }
    
    return request({
      url: '/inventory-management-api/api/upload/image',
      method: 'POST',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      skipInterceptor: true // 跳过请求拦截器的数据包装
    })
  }
}